/**
 * The quiz platform's roles, one per Cognito group and with no order among
 * them. Mirrors the CHECK on public.app_user_roles.role.
 */
export enum AppUserRole {
  Student = 'student',
  Teacher = 'teacher',
  Manager = 'manager',
  Admin = 'admin',
  Owner = 'owner',
}
